import React, { ReactElement, useEffect } from 'react';
import { graphql } from 'gatsby';
import { Component } from '../components/Contentful/component';
import { PrivateRoute } from '../components/Utils/privateRoute';
import { MainLayout } from '../components/UI/Layout/Main/mainLayout';

export default ({ data, pageContext }): ReactElement => {
  const page = data?.contentfulPage;
  const { allLocalSlugs } = pageContext;

  const {
    isPrivate,
    components,
    layout,
    popup,
    seoMetadata,
    slug,
    title,
    type,
    canonical,
    robots,
  } = page;

  const returnComponents = () =>
    components && components.map((component) => <Component {...component} />);

  const returnPageElement = () => {
    if (isPrivate) {
      return <PrivateRoute>{returnComponents()}</PrivateRoute>;
    }
    return returnComponents();
  };

  return (
    <PrivateRoute isPrivate={isPrivate}>
      <MainLayout
        {...layout}
        page={{
          seoMetadata,
          slug,
          type,
          title,
          canonical,
          robots,
          allLocalSlugs,
        }}
        popup={popup}>
        {returnPageElement()}
      </MainLayout>
    </PrivateRoute>
  );
};

export const pageQuery = graphql`
  query ProspectFormPageById($id: String!) {
    contentfulPage(id: { eq: $id }) {
      ...PageData
    }
  }
`;
